module.exports = __webpack_public_path__ + "static/sprite-491f674df0dd71afcbc514d109f201cb.svg";